/**
 * SyncScreen - Initial sync screen for mobile emulator
 */
import React from 'react';
import { Download, RefreshCw } from 'lucide-react';

interface SyncScreenProps {
  isOnline: boolean;
  isSyncing: boolean;
  onSync: () => void;
  onOpenDebug: () => void;
}

export const SyncScreen: React.FC<SyncScreenProps> = ({
  isOnline,
  isSyncing,
  onSync,
  onOpenDebug,
}) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center p-6">
      {/* Debug Button */}
      <button
        onClick={onOpenDebug}
        className="absolute top-4 right-4 bg-red-500 hover:bg-red-400 text-white px-3 py-2 rounded-full text-xs font-bold border-2 border-red-300"
        style={{
          fontSize: '11px',
          fontWeight: 'bold',
          minWidth: '60px',
          height: '28px',
          zIndex: 100,
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
        }}
        title="🔍 Abrir Debug Panel"
      >
        🔍 DEBUG
      </button>

      <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-6">
        <Download className="w-10 h-10 text-blue-600" />
      </div>

      <h2 className="text-2xl font-bold text-gray-900 mb-2">Bem-vindo!</h2>
      <p className="text-gray-600 text-center mb-8">Sincronize os dados para começar</p>

      <div className="bg-white rounded-lg border-2 border-gray-200 p-4 mb-8 w-full">
        <p className="font-semibold text-gray-900 mb-3">O que será baixado:</p>
        <ul className="space-y-2 text-sm text-gray-600">
          <li>• Lista de hospitais disponíveis</li>
          <li>• Catálogo de produtos</li>
          <li>• Configurações da conta</li>
        </ul>
      </div>

      {!isOnline && (
        <div className="bg-red-100 border-2 border-red-200 rounded-lg p-4 mb-4 w-full">
          <p className="text-red-800 text-sm font-medium">
            ⚠️ Você está offline. Ative o modo online para sincronizar.
          </p>
        </div>
      )}

      <button
        onClick={onSync}
        disabled={!isOnline || isSyncing}
        className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white py-3 px-6 rounded-lg font-semibold flex items-center justify-center gap-2 transition-colors"
      >
        {isSyncing ? (
          <>
            <RefreshCw className="w-5 h-5 animate-spin" />
            Sincronizando...
          </>
        ) : (
          <>
            <Download className="w-5 h-5" />
            Sincronizar Dados
          </>
        )}
      </button>
    </div>
  );
};
